import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable()
export class NotificationService {
  constructor() {
  }

  showLoadingScreen(mensaje: string) {
    Swal.fire({
      title: 'TNK Ledger',
      html: mensaje,
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  closeLoadingScreen() {
    Swal.close();
  }
}
